export enum SalesPageStates {
    Closed = 0,
    Active = 1,
    WaitingForApproval = 2
}
